import React from 'react'
import LineChart from './LineChart'
import LineChartSalesman from './LineChartSalesman'
import LineChartShopwise from './LineChartShopwise'
import ItemWiseReport from './ItemWiseReport'
import Container from '@mui/material/Container';
import { TextField } from '@mui/material';
import Grid from '@mui/material/Grid';
import ItemWiseSummaryReport from './ItemWiseSummaryReport'; 
import MaxSellPerHourReport from './MaxSellPerHourReport'; 
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import axios from "axios"

const Reports = ({user}) => {
  const [colCount, setColCount] = React.useState(4);
  const [type, setType] = React.useState("date");
  let d = new Date();
  const [endDate, setEndDate] = React.useState(d.toISOString().split('T')[0])
  d.setDate(d.getDate() - 7);
  const [startDate, setStartDate] = React.useState(d.toISOString().split('T')[0])
  const handleTypeChange = (event) => {
    if(event.target.value === "date") {
      setColCount(4)
      setType("date");
    } else if(event.target.value === "itemwisereport") {
      setColCount(4)
      setType("itemwisereport");
    } else if(event.target.value === "salesperson") {
      setColCount(4)
      setType("salesperson");
    } else if(event.target.value === "shopwisereport") {
      setColCount(4)
      setType("shopwisereport");
    } else if(event.target.value === "itemwisesummaryreport") { 
      setColCount(3)
      setType("itemwisesummaryreport");
	} else if(event.target.value === "maxSellPerHourReport") { 
      setColCount(3)
      setType("maxSellPerHourReport");
    }
  }
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  
  const [shopKey, setShopKey]  = React.useState(['PS','SK','GS','MRS','DS','SKR','BK','CBK']);
  const [shops, setShops] = React.useState([]);

  const getShops = async(user) => {
    try {
      const res = await axios.get("/shops", {headers: {token:"Bearer " + user.token}})
      const checkedShops = [];
      res.data.map(shop => {
        checkedShops.push({ ...shop, checked: true}) 
        return shop
      });
      setShops(checkedShops) 
    } catch (err) {
      console.log(err) 
    }
  };
  React.useEffect(() => {
    getShops(user); 
  },[user]);

  const handleShopChange = (event) => {
    const {  target: { value }, } = event;
    setShopKey(
      typeof value === 'string' ? value.split(',') : value,
    ); 
  };

  return (
    <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
      <Grid container sx={{ padding: 1}} >
        <Grid item xs={colCount}><TextField label="Start date" type="date" defaultValue={startDate} InputLabelProps={{ shrink: true, }} variant="standard" SelectProps={{native: true}} fullWidth onChange={(event)=> setStartDate(event.target.value)}/></Grid>
        <Grid item xs={colCount} sx={{ paddingLeft: 1}}><TextField label="End date" type="date" defaultValue={endDate} InputLabelProps={{ shrink: true, }} variant="standard" SelectProps={{native: true}} fullWidth onChange={(event)=> setEndDate(event.target.value)}/></Grid>
        <Grid item xs={colCount} sx={{ paddingLeft: 1}}>
          <TextField select label="Select Report Type" value={type} onChange={handleTypeChange} variant="standard" SelectProps={{native: true}} fullWidth>
            <option key="date" value="date">Daily Sales Report</option>
            <option key="itemwisereport" value="itemwisereport">Item Wise Sales Report</option>
            {user.isAdmin && <option key="salesperson" value="salesperson">Person Wise Sales Report</option>}
            {user.isAdmin && <option key="shopwisereport" value="shopwisereport">Daily Sales Report - Shop Wise</option>}
            {user.isAdmin && <option key="itemwisesummaryreport" value="itemwisesummaryreport">Item Wise Summary Report</option>}  
			{user.isAdmin && <option key="maxSellPerHourReport" value="maxSellPerHourReport">Max Sell Per Hour Report</option>} 
          </TextField>
        </Grid>
  
        {type === "itemwisesummaryreport" &&    
        <Grid item xs={colCount} sx={{ paddingLeft: 2}}>
            <FormControl sx={{ width: 400 }}>
                <InputLabel id="lblChkShopKey">Shops</InputLabel>
                <Select
                  labelId="lblChkShopKey"
                  id="chkShopKey"
                  multiple
                  value={shopKey}
                  onChange={handleShopChange}
                  input={<OutlinedInput label="Shops" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {shops.map((shop) => (
                    <MenuItem key={shop.shopkey} value={shop.shopkey}> 
                      <Checkbox checked={shopKey.indexOf(shop.shopkey) > -1} /> 
                      <ListItemText primary={shop.shopname + ' (' + shop.shopkey +')'}  />
                    </MenuItem>
                  ))}
              
			  </Select>
              </FormControl>
          </Grid>  }  
          {type === "maxSellPerHourReport" &&    
        <Grid item xs={colCount} sx={{ paddingLeft: 2}}>
            <FormControl sx={{ width: 400 }}>
                <InputLabel id="lblChkShopKey">Shops</InputLabel>
                <Select
                  labelId="lblChkShopKey"
                  id="chkShopKey"
                  multiple
                  value={shopKey}
                  onChange={handleShopChange}
                  input={<OutlinedInput label="Shops" />}
                  renderValue={(selected) => selected.join(', ')}
                  MenuProps={MenuProps}
                >
                  {shops.map((shop) => (
                    <MenuItem key={shop.shopkey} value={shop.shopkey}> 
                      <Checkbox checked={shopKey.indexOf(shop.shopkey) > -1} /> 
                      <ListItemText primary={shop.shopname + ' (' + shop.shopkey +')'}  />
                    </MenuItem>
                  ))}
				  
                </Select>
              </FormControl>
          </Grid>  }  
      </Grid>
      {type === "date" && <LineChart startDate={startDate} endDate={endDate} />}
      {type === "salesperson" && <LineChartSalesman startDate={startDate} endDate={endDate} />}
      {type === "shopwisereport" && <LineChartShopwise startDate={startDate} endDate={endDate} /> }
      {type === "itemwisereport" && <ItemWiseReport startDate={startDate} endDate={endDate} />}
      {type === "itemwisesummaryreport" && <ItemWiseSummaryReport startDate={startDate} endDate={endDate} shopKeys={shopKey}/> }
	  {type === "maxSellPerHourReport" && <MaxSellPerHourReport startDate={startDate} endDate={endDate} shopKeys={shopKey}/> }
    </Container>
  )
}

export default Reports
